<p-toast></p-toast>
<div #documentCommentModal class="documentCommentModal">
    <p-dialog
      header="Document Comments"
      [(visible)]="openDocumentCommentModal"
      [draggable]="false"
      [style]="{ width: '85vw', height: '85vh' }"
      (onHide)="closeModal()"
      [modal]="true"
      id="documentVersionCommentModal"
    >
    <div class="documentCommentPanelList" *ngIf="showPanelList" id="documentCommentPanelList">
      <app-panel-list 
      [panelList]="documentCommentModalInput" 
      [noResultFound] = "noResultFound">
        <ng-template #templateRef let-data="dataVar">
          <div panel-content class="grid documentCommentPanelCards">
            <div class="col-fixed text-left" style="width: 20%">
              <div class="grid">
                <div class="col-fixed text-left">
                    <app-label labelText="Created By"></app-label>
                    <app-read-only 
                    [ngClass]="{'inActiveGroup':data?.createdByInformation.isTerminated===true}"
                    readonlyText="{{ data?.createdBy}}"></app-read-only>
                </div>
              </div>
              <div class="grid">
                <div class="col-fixed text-left">
                    <app-label labelText="Creation Date"></app-label>
                    <app-read-only readonlyText="{{ data?.creationDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
                  </div>
              </div>
            </div>

            <div class="col-fixed text-left" style="width: 80%">
              <app-label labelText="Comment"></app-label>
              <app-read-only readonlyText="
                {{ data?.commentText }}"></app-read-only>
            </div>
          </div>
        </ng-template>
      </app-panel-list>
    </div>
      <div class="addDocumentCommentBtn mt-2 p-2" id="addDocumentCommentBtn">
        <p-button
        appPreventDoubleClick
        (debounceClick)="addComment()"
          [disabled]="!isAddCommentButtonVisible"
          label="+ Add Comment"
          type="submit"
          id="addDocumentCommentButton"
          class="align-right align-self-end"
          styleClass="bpt-button-compact"
        >
        </p-button>
      </div>
    <div class="documentCommentCreation" *ngIf="openAddDocumentSlider">
        <app-document-comment-creation-slider
        [isSliderOpen]="openAddDocumentSlider"
        (isSliderActive)="isSliderActive($event)"
        (reloadDocumentComments)="reloadDocumentComments($event)"
        [documentNumber]="documentNumber"
        [documentVersion]="documentVersion">
    </app-document-comment-creation-slider>
      </div>
    </p-dialog>
  </div>
